import { gql } from "@apollo/client";

export const QUERY_GET_ALL_CONTINUUM_LICENSES = gql`
  query GetAllContinuumLicenses {
    getAllContinuumLicenses {
      id
      licenseId
      product
      email
      customerName
      jiraTicket
      serviceDeskID
      department
      licenseType
      licenseCategory
      platformEffectiveDate
      platformExpiryDate
      modernizationAllowed
      linesOfCode
      carryOverLOC
      continuumCarryover
      licenseStatus
      createdBy
      approvedBy
      denialReason
    }
  }
`;

export const QUERY_GET_CONTINUUM_LICENSE = gql`
  query GetContinuumLicense($licenseId: String!) {
    getContinuumLicense(licenseId: $licenseId) {
      licenseId
      platformExpiryDate
      licenseStatus
      createdBy
      approvedBy
      denialReason
    }
  }
`;

export const QUERY_GET_ALL_SCANNER_LICENSES = gql`
  query GetAllScannerLicenses {
    getAllScannerLicenses {
      id
      licenseId
      email
      customerName
      jiraTicket
      serviceDeskID
      department
      licenseType
      scannerEffectiveDate
      scannerExpiryDate
      licenseStatus
    }
  }
`;

export const QUERY_GET_MACHINE_HISTORY = gql`
  query GetMachineHistory($licenseId: String!) {
    getMachineHistory(licenseId: $licenseId) {
      id
      licenseId
      machineFingerprint
      status
      activatedAt
      activatedByEmail
      deactivationRequestedAt
      deactivationRequestedByEmail
      deactivatedAt
      deactivatedByEmail
    }
  }
`;

export const QUERY_GET_MACHINE_FINGERPRINTS = gql`
  query GetMachineFingerprints($machineId: Float!) {
    getMachineFingerprints(machineId: $machineId)
  }
`;

export const QUERY_GET_ACTIVATION_KEY_HISTORY = gql`
  query GetActivationKeyHistory($licenseId: String!) {
    getActivationKeyHistory(licenseId: $licenseId) {
      id
      licenseId
      machineId
      activationKey
      generatedAt
      expiryDate
      activatedByEmail
    }
  }
`;

export const QUERY_GET_DEACTIVATION_KEY_HISTORY = gql`
  query GetDeactivationKeyHistory($licenseId: String!) {
    getDeactivationKeyHistory(licenseId: $licenseId) {
      id
      licenseId
      machineId
      deactivationKey
      deactivationRequestId
      issuedAt
      expiresAt
      consumedAt
      requestedByEmail
      deactivatedByEmail
    }
  }
`;

export const QUERY_GET_CONTINUUM_LICENSE_TEXT = gql`
  query GetContinuumLicenseText($licenseId: String!) {
    getContinuumLicenseText(licenseId: $licenseId) {
      licenseText
    }
  }
`;

export const QUERY_GET_SCANNER_LICENSE_TEXT = gql`
  query GetScannerLicenseText($licenseId: String!) {
    getScannerLicenseText(licenseId: $licenseId) {
      licenseText
    }
  }
`;
